<template>
    <div :class="searchClassName">
        <app-button class="app-search__mobile-button"
                    @click="handleMobileButtonClick"
        >
            <app-icon class="app-search__search-icon" value="icon-search" slot="icon"/>
        </app-button>
        <div class="app-search__inner">
            <app-button class="app-search__search"
                        @click="emitSearch"
            >
                <app-icon class="app-search__search-icon" value="icon-search" slot="icon"/>
            </app-button>
            <input class="app-search__input"
                   type="text"
                   placeholder="搜索"
                   v-model="query"
                   ref="searchInput"
                   @keyup.enter="emitSearch"
            >
            <!-- clear -->
            <app-button class="app-search__clear"
                        v-if="query"
                        @click="handleClear"
            >
                <app-icon class="app-search__clear-icon" value="icon-close"/>
            </app-button>
            <!-- close -->
            <app-button class="app-search__close"
                        @click="handleClose"
            >
                <app-icon class="app-search__clear-icon" value="icon-close"/>
            </app-button>
        </div>
    </div>
</template>

<script>
    import AppIcon from '../AppIcon'
    import AppButton from '../AppButton'

    export default {
        name: 'AppSearch',
        data() {
            return {
                query: '',
                full: false
            }
        },
        computed: {
            params() {
                const params = this.$route.query
                return params.query || ''
            },
            searchClassName() {
                const {full} = this
                return ['app-search', full ? 'full' : undefined]
            }
        },
        watch: {
            params: {
                handler(query) {

                    this.query = query

                },
                immediate: true
            }
        },
        methods: {
            handleClear() {
                this.query = ''
                this.emitSearch()
            },
            emitSearch() {
                const {query} = this
                if (query) {
                    this.$emit('search', query)
                }
            },
            handleMobileButtonClick() {
                this.full = true
                this.$nextTick(() => {
                    this.$refs.searchInput.focus()
                })
            },
            handleClose() {
                this.full = false
                this.handleClear()
            }
        },
        components: {
            AppButton,
            AppIcon
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-search {
        display: inline-block;
        background-color: $backgroundColor;
        background-color: var(--backgroundColor);
        @include transition-colors;

        &__mobile-button {
            position: relative;
            display: none;
            width: 40px;
            height: 40px;
            font-size: $fontSize;
            font-weight: $fontWeightBolder;

            .app-search__search-icon {
                position: absolute;
                font-size: $fontSize;
                left: (40px - $fontSize)/2;
                top: (40px - $fontSize)/2;
            }
        }

        &__inner {
            position: relative;
        }

        &__search,
        &__clear,
        &__close {
            position: absolute;
            top: 0;
            display: inline-block;
            line-height: 40px;
            padding: 0 $paddingMD;
        }

        &__search {
            left: 0;
            padding-right: 0;
        }

        &__clear,
        &__close {
            right: 0;
        }

        &__close {
            display: none;
        }

        &__search-icon,
        &__clear-icon {
            font-size: $fontSizeMD;
            font-weight: $fontWeightBolder;
        }

        &__input {
            width: 100%;
            height: 40px;
            padding: 0 16px 0 40px;
            border-radius: 9999px;
            font-size: $fontSizeCommon;
            font-weight: $fontWeightBolder;
            color: $textColor;
            color: var(--textColor);
            background-color: $componentHighLightColor;
            background-color: var(--componentHighLightColor);
            outline: none;
            @include transition-colors;

            &::placeholder {
                opacity: .5;
            }
        }
    }

    @media (max-width: 640px) {
        .app-search {

            &.full {
                display: flex;
                align-items: center;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;

                .app-search__inner {
                    display: inline-block;
                    margin: 0 $paddingMD;
                    width: 100%;
                }

                .app-search__mobile-button {
                    display: none;
                }

                .app-search__clear {
                    display: none;
                }

                .app-search__close {
                    display: inline-block;
                }
            }

            &__inner {
                display: none;
            }

            &__mobile-button {
                display: inline-block;
            }
        }
    }
</style>